<div [formGroup]="form">
    <div class="row">
        <div class="apc-form-card">
            <span class="title">{{'person.extras.metadata' | translate}}</span>
            <div class="container-fluid my-2">
                <div class="row">
                    <div class="form-group col-lg-6">
                        <apc-form-select formControlName="extraTypeIdentifier" [items]="typesDropdown" optionValue="identifier" [renderValue]="findDropdownRenderValue()" [isRequired]="true">
                            <label label>{{'person.extras.typology' | translate}}</label>
                        </apc-form-select>
                    </div>

                    <div class="form-group col-lg-6 mt-4">
                        <label class="file-upload" [ngClass]="fileRequired ? 'file-required' : ''">
                            <input type="file" (change)="handleFileInput($event.target['files'])" />
                            {{'person.extras.fileSelect' | translate}} *
                        </label>
                    </div>

                    <div class="form-group col-lg-6 mt-4">
                        <apc-form-input [class]="'form-control autogenerated'" [disabled]="true" formControlName="fileName" [type]="'text'">
                        </apc-form-input>
                    </div>
                    <div class="form-group col-lg-6 mt-4">
                        <apc-form-input [class]="'form-control autogenerated'" [disabled]="true" formControlName="fileSize" [type]="'text'">
                        </apc-form-input>
                        <div class="error-file-message" *ngIf="form.controls.fileSize.errors?.fileSize">
                            {{ 'person.extras.maxFileSize' | translate }}
                        </div>
                    </div>

                    <div class="form-group col-lg mt-4">
                        <label>{{'person.extras.description' | translate}}</label>
                        <apc-form-input [class]="'form-control'" formControlName="description" [type]="'textarea'" [rows]="'4'">
                        </apc-form-input>
                    </div>
                </div>
            </div>
        </div>
    </div>